import ApplicationSerializer from 'lumen/serializers/application';

export default class SmartInsightsHotelSerializer extends ApplicationSerializer {
  attrs = {
    propertyTags: {
      serialize: false,
    },
  };

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  modelNameFromPayloadKey(key: string) {
    if (key === 'hotels') {
      return 'smart-insights/hotel';
    }

    if (key === 'property_tags') {
      return 'smart-insights/property-tags';
    }

    if (key === 'users') {
      return 'smart-insights/property-tags/user';
    }

    if (key === 'subscriptions') {
      return 'smart-insights/property-tags/subscription';
    }

    return key;
  }

  // Added this normalize method paired with `serialize: false` above, to fix this error.
  // Tried resolving this using `pathForType` in an adapter, but that didn't work.
  // Error: Missing Schema: Encountered a relationship identifier with type 'smart-insights/property-tag' for the belongsTo relationship 'propertyTags'
  // on <smart-insights/hotel:157558>, Expected an identifier with type 'smart-insights/property-tags'. No schema was found for 'smart-insights/property-tag'.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  normalize(
    modelClass: unknown,
    resourceHash: Record<string, unknown>,
    prop?: string,
  ) {
    // Override the relationship data to use the correct model type
    if (resourceHash['subscription_id']) {
      resourceHash['property_tags'] = {
        type: 'smart-insights/property-tags',
        id: resourceHash['subscription_id'],
      };
    }

    // eslint-disable-next-line @typescript-eslint/no-unsafe-return, @typescript-eslint/no-unsafe-call
    return super.normalize(modelClass, resourceHash, prop);
  }

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  normalizeResponse(
    store: unknown,
    primaryModelClass: unknown,
    payload: Record<string, unknown>,
    id: unknown,
    requestType: unknown,
  ) {
    // Copy subscription_id to id for hotels so they have proper primary keys
    if (Array.isArray(payload['hotels'])) {
      (payload['hotels'] as Record<string, unknown>[]).forEach((hotel) => {
        if (hotel['subscription_id'] && !hotel['id']) {
          hotel['id'] = hotel['subscription_id'];
        }
      });
    }

    // Flatten the nested property_tags structure
    if (
      payload['property_tags'] &&
      typeof payload['property_tags'] === 'object' &&
      payload['property_tags'] !== null
    ) {
      const propertyTagsData = payload['property_tags'] as Record<
        string,
        unknown
      >;

      if (propertyTagsData['property_tags']) {
        payload['property_tags'] = propertyTagsData['property_tags'];

        // Copy subscription_id to id for property_tags as well
        if (Array.isArray(payload['property_tags'])) {
          (payload['property_tags'] as Record<string, unknown>[]).forEach(
            (propertyTag) => {
              if (propertyTag['subscription_id'] && !propertyTag['id']) {
                propertyTag['id'] = propertyTag['subscription_id'];
              }
            },
          );
        }
      }

      if (propertyTagsData['users']) {
        payload['users'] = propertyTagsData['users'];
      }

      if (propertyTagsData['subscriptions']) {
        payload['subscriptions'] = propertyTagsData['subscriptions'];
      }
    }

    // eslint-disable-next-line @typescript-eslint/no-unsafe-return, @typescript-eslint/no-unsafe-call
    return super['normalizeResponse'](
      store,
      primaryModelClass,
      payload,
      id,
      requestType,
    );
  }
}
